export const getClientSessionExpiry = (session, requestStartedAt) => {
  if (!session?.access_token || !session?.refresh_token ||
      !Number.isFinite(session.expires_in) || session.expires_in <= 0) return null;

  // Only translate the refresh schedule to the device clock. The signed JWT and
  // its server-enforced expiration remain untouched.
  return Math.floor(requestStartedAt / 1000) + session.expires_in;
};

export const createAuthSessionFetch = (supabaseUrl, fetchImplementation) => {
  const origin = new URL(supabaseUrl).origin;

  return async (input, init) => {
    const startedAt = Date.now();
    const response = fetchImplementation
      ? await fetchImplementation(input, init)
      : await fetch(input, init);
    const url = new URL(typeof input === "string" || input instanceof URL ? input : input.url);
    const method = String(init?.method || input?.method || "GET").toUpperCase();
    if (!response.ok || method !== "POST" || url.origin !== origin ||
        !["/auth/v1/token", "/auth/v1/verify", "/auth/v1/signup"].includes(url.pathname)) return response;

    let session;
    try { session = await response.clone().json(); }
    catch { return response; }
    const expiresAt = getClientSessionExpiry(session, startedAt);
    if (expiresAt === null) return response;

    const headers = new Headers(response.headers);
    headers.delete("content-length");
    headers.delete("content-encoding");
    return new Response(JSON.stringify({ ...session, expires_at: expiresAt }), {
      status: response.status, statusText: response.statusText, headers,
    });
  };
};
